import styled from "styled-components";
import React from "react";



const HistoryOption = ({status, type, date, onClick}) => {
    return (
        <StyledHistoryOption onClick={onClick} status={status}>
            <div className="type">
                <span className="status"/>
                <b>{type}</b>
            </div>
            <div className="date">
                {date}
            </div>
        </StyledHistoryOption>
    )
}
const StyledHistoryOption = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-weight: normal;
  cursor: pointer;
  .type {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .status {
      width: 8px;
      height: 8px;
      background: ${p => p.status ? "#07B51A" : '#FF007C'};
      border-radius: 100px;
      margin-right: 10px;
    }

    .date {
      font-weight: normal;
    }
  }
`

export default HistoryOption